/** True for phone/tablet browsers — web T&C gate is skipped on these clients. */
export function isMobileWebClient(): boolean {
  if (globalThis.window === undefined) return false;

  const ua = navigator.userAgent || "";
  const mobileUa =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrowViewport = globalThis.innerWidth <= 768;

  return mobileUa || (narrowViewport && "ontouchstart" in globalThis);
}
